import type { PageLoad } from './$types';
import { getUser } from '$lib/api/users';
import { error } from '@sveltejs/kit';

export const load: PageLoad = ({ params, fetch }) => {
  if (!params.id) error(404);
  const id = parseInt(params.id);
  if (isNaN(id)) error(404);
  const user = getUser(id, fetch);
  return {
    userPromise: user,
    meta: {
      title: 'Student',
      activeNav: 'users',
      breadcrumbs: {
        activeTitle: user.then(u => `${u.lastName}, ${u.firstName}`),
        items: [
          {
            title: 'Users',
            href: '/admin/users',
          },
          {
            title: 'Admins',
            href: '/admin/users/admins',
          },
        ],
      },
    },
  };
};
